import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './IncentiveCreateScreen';
import IncentiveCreate from './IncentiveCreateScreen';
import { StoreState } from 'src/store/reducers';
import { getFormValues } from 'redux-form';
import { getProvidersIncentive } from 'src/store/actions/incentive-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.incentives.inProgress,
        providersIncentive: state.incentives.providerPayload,
        valuesForm: getFormValues('incentive-form')(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProvidersIncentive: (data: { dateFrom: string; dateTo: string }) => dispatch(getProvidersIncentive(data)),
    };
}

const IncentiveCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(IncentiveCreate);

export default IncentiveCreateScreen;
